<div class="main-content profile-editor-page inventario-ia-editor-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>{{ esEdicion ? "Editar" : "Nuevo" }} activo IA</h1>
        <p>
          ISO/IEC 42001 — Formato FDS-043. Documenta el sistema de IA con todos
          los atributos requeridos para auditoría.
        </p>
        <p
          class="inventario-ia-editor-page__folio"
          *ngIf="esEdicion && inventario.consecutivo"
        >
          Folio asignado: <strong>{{ inventario.consecutivo }}</strong>
          <span class="inventario-ia-editor-page__folio-hint">
            (autogenerado por el sistema)
          </span>
        </p>
      </div>

    </section>

    <div
      class="table-page__empty inventario-ia-editor-page__error"
      *ngIf="error"
    >
      <i class="material-icons">error_outline</i>
      <strong>{{ error }}</strong>
    </div>

    <form #f="ngForm" novalidate (ngSubmit)="guardar()" class="inventario-ia-editor-page__form">
      <!-- 1. IDENTIFICACIÓN -->
      <section class="profile-editor-page__card inventario-ia-editor-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title">
            <i class="material-icons">smart_toy</i>
            <span>1. Identificación</span>
          </div>
          <span>Datos generales para identificar el sistema de IA.</span>
        </div>

        <div class="profile-editor-page__card-body">
          <div class="row inventario-ia-editor-page__grid">
            <div class="col-md-8">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Nombre del sistema de IA *</mat-label>
                <input
                  aria-label="Nombre del sistema de IA *"
                  matInput
                  [(ngModel)]="inventario.nombreIa"
                  name="nombreIa"
                  required
                />
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Versión</mat-label>
                <input aria-label="Versión" matInput [(ngModel)]="inventario.version" name="version" />
              </mat-form-field>
            </div>

            <!-- Áreas donde se usa (selección múltiple sobre el mismo catálogo
                 de adm_area del campo "Área propietaria"). Alimenta la
                 coherencia con el censo de uso de IA por área. -->
            <div class="col-12">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="profile-editor-page__field"
              >
                <mat-label>Áreas donde se utiliza</mat-label>
                <mat-select
                  multiple
                  [(ngModel)]="inventario.idAreasUsuarias"
                  name="areasUsuarias"
                  placeholder="Selecciona una o varias áreas"
                >
                  <mat-option *ngFor="let a of areas" [value]="a.id">
                    {{ a.area }}
                  </mat-option>
                </mat-select>
                <mat-hint>Selecciona todas las áreas que usan este sistema de IA.</mat-hint>
              </mat-form-field>
            </div>

            <!-- floatLabel="always": el título se mantiene arriba aunque el campo
                 esté vacío, y así el placeholder de ejemplo queda visible como guía. -->
            <div class="col-12">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="profile-editor-page__field"
              >
                <mat-label>Propósito</mat-label>
                <textarea
                  aria-label="Propósito"
                  matInput
                  rows="3"
                  [(ngModel)]="inventario.proposito"
                  name="proposito"
                  placeholder="Para qué existe el sistema. Ej.: Automatizar la clasificación y respuesta inicial de las solicitudes operativas del COS para reducir el tiempo de atención."
                ></textarea>
              </mat-form-field>
            </div>

            <div class="col-12">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="profile-editor-page__field"
              >
                <mat-label>Uso previsto</mat-label>
                <textarea
                  aria-label="Uso previsto"
                  matInput
                  rows="3"
                  [(ngModel)]="inventario.usoPrevisto"
                  name="usoPrevisto"
                  placeholder="Quién lo usa, en qué proceso y qué NO debe hacer. Ej.: Lo utiliza el personal de Mesa de Control sobre solicitudes internas; la respuesta es una sugerencia y siempre la valida un operador. No se usa para decisiones laborales ni con datos personales sensibles."
                ></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </section>

      <!-- 2. PROPIETARIO -->
      <section class="profile-editor-page__card inventario-ia-editor-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title">
            <i class="material-icons">business</i>
            <span>2. Propietario</span>
          </div>
          <span>
            Indica si el activo pertenece a un área interna o a un proveedor /
            propietario externo.
          </span>
        </div>

        <div class="profile-editor-page__card-body">
          <mat-radio-group
            [(ngModel)]="modoPropietario"
            name="modoPropietario"
            (change)="cambiarModoPropietario()"
            class="inventario-ia-editor-page__radio-row"
          >
            <mat-radio-button value="AREA">Área interna</mat-radio-button>
            <mat-radio-button value="EXTERNO">Externo</mat-radio-button>
          </mat-radio-group>

          <div class="row inventario-ia-editor-page__grid">
            <div class="col-md-8" *ngIf="modoPropietario === 'AREA'">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Área propietaria *</mat-label>
                <mat-select [(ngModel)]="inventario.idArea" name="idArea">
                  <mat-option [value]="null">— Selecciona un área —</mat-option>
                  <mat-option *ngFor="let a of areas" [value]="a.id">
                    {{ a.area }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-8" *ngIf="modoPropietario === 'EXTERNO'">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Propietario externo *</mat-label>
                <input
                  aria-label="Propietario externo *"
                  matInput
                  [(ngModel)]="inventario.propietarioExterno"
                  name="propietarioExterno"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </section>

      <!-- 3. CICLO DE VIDA Y OPERACIÓN -->
      <section class="profile-editor-page__card inventario-ia-editor-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title">
            <i class="material-icons">timeline</i>
            <span>3. Ciclo de vida y operación</span>
          </div>
          <span>Etapa actual, fechas de vigencia y supervisión humana.</span>
        </div>

        <div class="profile-editor-page__card-body">
          <div class="row inventario-ia-editor-page__grid">
            <div class="col-md-3">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Etapa del ciclo de vida</mat-label>
                <mat-select [(ngModel)]="inventario.idCicloVida" name="idCicloVida">
                  <mat-option *ngFor="let c of ciclosVida" [value]="c.idCicloVida">
                    {{ c.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Fecha alta</mat-label>
                <input
                  aria-label="Fecha alta"
                  matInput
                  [matDatepicker]="pickerAlta"
                  [(ngModel)]="inventario.fechaAlta"
                  name="fechaAlta"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerAlta"></mat-datepicker-toggle>
                <mat-datepicker #pickerAlta></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Fecha baja</mat-label>
                <input
                  aria-label="Fecha baja"
                  matInput
                  [matDatepicker]="pickerBaja"
                  [(ngModel)]="inventario.fechaBaja"
                  name="fechaBaja"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerBaja"></mat-datepicker-toggle>
                <mat-datepicker #pickerBaja></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Supervisión humana</mat-label>
                <mat-select
                  [(ngModel)]="inventario.idNivelSupervision"
                  name="idNivelSupervision"
                >
                  <mat-option
                    *ngFor="let n of nivelesSupervision"
                    [value]="n.idNivelSupervision"
                  >
                    {{ n.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-12">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Ubicación (cloud / on-prem / proveedor)</mat-label>
                <input aria-label="Ubicación (cloud / on-prem / proveedor)" matInput [(ngModel)]="inventario.ubicacion" name="ubicacion" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </section>

      <!-- 4. RECURSOS -->
      <section class="profile-editor-page__card inventario-ia-editor-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title">
            <i class="material-icons">settings_input_component</i>
            <span>4. Recursos</span>
          </div>
          <span>
            Componentes técnicos, fuentes de datos, herramientas, infraestructura
            y personas involucradas.
          </span>
        </div>

        <div class="profile-editor-page__card-body">
          <div class="row inventario-ia-editor-page__grid">
            <div class="col-md-6">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Componentes del sistema de IA</mat-label>
                <textarea
                  aria-label="Componentes del sistema de IA"
                  matInput
                  rows="2"
                  [(ngModel)]="inventario.componentesSistema"
                  name="componentesSistema"
                  placeholder="Ej. TensorFlow, PyTorch"
                ></textarea>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Datos</mat-label>
                <textarea
                  aria-label="Datos"
                  matInput
                  rows="2"
                  [(ngModel)]="inventario.componentesDatos"
                  name="componentesDatos"
                ></textarea>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Herramientas de IA</mat-label>
                <textarea
                  aria-label="Herramientas de IA"
                  matInput
                  rows="2"
                  [(ngModel)]="inventario.herramientasIa"
                  name="herramientasIa"
                ></textarea>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Sistemas y recursos informáticos</mat-label>
                <textarea
                  aria-label="Sistemas y recursos informáticos"
                  matInput
                  rows="2"
                  [(ngModel)]="inventario.sistemasInformaticos"
                  name="sistemasInformaticos"
                ></textarea>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Recursos humanos / roles</mat-label>
                <textarea
                  aria-label="Recursos humanos / roles"
                  matInput
                  rows="2"
                  [(ngModel)]="inventario.recursosHumanos"
                  name="recursosHumanos"
                  placeholder="Ej. Ingenieros de datos, especialistas en ética"
                ></textarea>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field appearance="outline" class="profile-editor-page__field">
                <mat-label>Procesos en los que interviene</mat-label>
                <textarea
                  aria-label="Procesos en los que interviene"
                  matInput
                  rows="2"
                  [(ngModel)]="inventario.procesosIntervencion"
                  name="procesosIntervencion"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </section>

      <!-- 5. IMPACTOS -->
      <section class="profile-editor-page__card inventario-ia-editor-page__card">
        <div
          class="profile-editor-page__card-header profile-editor-page__card-header--tree"
        >
          <div class="inventario-ia-editor-page__impacto-head">
            <div class="profile-editor-page__card-title">
              <i class="material-icons">analytics</i>
              <span>5. Impactos identificados</span>
            </div>
            <span class="inventario-ia-editor-page__impacto-subtitle">
              Registra los impactos positivos y negativos del activo. Al agregar
              uno, eliges su tipo (según ISO/IEC 42001) y describes su efecto
              positivo y negativo.
            </span>
          </div>

          <button
            type="button"
            class="app-form-btn app-form-btn--primary app-form-btn--compact"
            (click)="agregarImpacto()"
          >
            <i class="material-icons">add</i>
            Agregar impacto
          </button>
        </div>

        <div class="profile-editor-page__card-body">
          <div
            class="table-page__empty-state"
            *ngIf="!inventario.impactos?.length"
          >
            <i class="material-icons">analytics</i>
            <p>
              Sin impactos registrados. Agrega al menos uno para documentar la
              evaluación de riesgos.
            </p>
          </div>

          <div
            *ngFor="let imp of inventario.impactos; let i = index"
            class="inventario-ia-editor-page__impacto-row"
          >
            <div class="row inventario-ia-editor-page__grid">
              <div class="col-md-3">
                <mat-form-field appearance="outline" class="profile-editor-page__field">
                  <mat-label>Tipo de impacto</mat-label>
                  <mat-select
                    [(ngModel)]="imp.idTipoImpacto"
                    [name]="'tipoImp' + i"
                    (selectionChange)="onTipoImpactoChange(imp)"
                    panelClass="impacto-tipo-panel"
                  >
                    <mat-optgroup label="Evaluación de impactos potenciales">
                      <mat-option
                        *ngFor="let t of tiposPotenciales; trackBy: trackTipo"
                        [value]="t.idTipoImpacto"
                        [disabled]="tipoBloqueado(t.idTipoImpacto, imp)"
                        [matTooltip]="t.nota"
                        matTooltipPosition="right"
                        matTooltipClass="impacto-tooltip"
                      >
                        {{ t.nombre
                        }}<span *ngIf="t.seccion === 'AMBAS'" class="impacto-ambas-tag"
                          >ambas secciones</span
                        >
                      </mat-option>
                    </mat-optgroup>

                    <mat-optgroup
                      label="Evaluación de los impactos sociales de los sistemas de IA"
                    >
                      <mat-option
                        *ngFor="let t of tiposSociales; trackBy: trackTipo"
                        [value]="t.idTipoImpacto"
                        [disabled]="tipoBloqueado(t.idTipoImpacto, imp)"
                        [matTooltip]="t.nota"
                        matTooltipPosition="right"
                        matTooltipClass="impacto-tooltip"
                      >
                        {{ t.nombre
                        }}<span *ngIf="t.seccion === 'AMBAS'" class="impacto-ambas-tag"
                          >ambas secciones</span
                        >
                      </mat-option>
                    </mat-optgroup>

                    <mat-optgroup *ngIf="tiposSinClasificar.length" label="Otros">
                      <mat-option
                        *ngFor="let t of tiposSinClasificar; trackBy: trackTipo"
                        [value]="t.idTipoImpacto"
                        [disabled]="tipoBloqueado(t.idTipoImpacto, imp)"
                        [matTooltip]="t.nota"
                        matTooltipPosition="right"
                        matTooltipClass="impacto-tooltip"
                      >
                        {{ t.nombre }}
                      </mat-option>
                    </mat-optgroup>

                    <mat-optgroup
                      *ngIf="tiposHistoricos.length"
                      label="Histórico (tipos anteriores)"
                    >
                      <mat-option
                        *ngFor="let t of tiposHistoricos; trackBy: trackTipo"
                        [value]="t.idTipoImpacto"
                        [disabled]="tipoBloqueado(t.idTipoImpacto, imp)"
                      >
                        {{ t.nombre }}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field
                  appearance="outline"
                  floatLabel="always"
                  class="profile-editor-page__field"
                  [class.impacto-campo-vacio]="!imp.descripcionPositivo"
                >
                  <mat-label>Impacto positivo</mat-label>
                  <textarea
                    aria-label="Impacto positivo"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="16"
                    [(ngModel)]="imp.descripcionPositivo"
                    [name]="'impPos' + i"
                    placeholder="Aún sin texto — describe el impacto positivo"
                    [matTooltip]="imp.descripcionPositivo || ''"
                    matTooltipClass="impacto-texto-tooltip"
                    matTooltipPosition="above"
                    [matTooltipShowDelay]="400"
                  ></textarea>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field
                  appearance="outline"
                  floatLabel="always"
                  class="profile-editor-page__field"
                  [class.impacto-campo-vacio]="!imp.descripcionNegativo"
                >
                  <mat-label>Impacto negativo</mat-label>
                  <textarea
                    aria-label="Impacto negativo"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="16"
                    [(ngModel)]="imp.descripcionNegativo"
                    [name]="'impNeg' + i"
                    placeholder="Aún sin texto — describe el impacto negativo"
                    [matTooltip]="imp.descripcionNegativo || ''"
                    matTooltipClass="impacto-texto-tooltip"
                    matTooltipPosition="above"
                    [matTooltipShowDelay]="400"
                  ></textarea>
                </mat-form-field>
              </div>

              <div class="col-md-1 inventario-ia-editor-page__impacto-action">
                <button
                  type="button"
                  class="table-page__action-btn table-page__action-btn--danger"
                  (click)="eliminarImpacto(i)"
                  title="Eliminar impacto"
                >
                  <i class="material-icons">delete</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Regresar y Actualizar, pegados abajo mientras se rueda.
           Estaban arriba, en el encabezado: la ficha del FDS-043 es
           larga y al bajar a llenarla los botones se quedaban fuera de
           la pantalla, asi que habia que volver hasta el principio para
           guardar. Aqui, al final del formulario y con position sticky,
           siempre estan a mano. -->
      <div class="profile-editor-page__hero-actions inventario-ia-editor-page__acciones">
        <button
          type="button"
          class="app-form-btn app-form-btn--secondary"
          (click)="cancelar()"
        >
          Regresar
        </button>
        <button
          type="button"
          class="app-form-btn app-form-btn--primary"
          [disabled]="guardando"
          (click)="guardar()"
        >
          {{ guardando ? "Guardando…" : esEdicion ? "Actualizar" : "Guardar" }}
        </button>
      </div>
    </form>
  </div>
</div>
